import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <main className="pt-20 pb-20">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-4">分类未找到</h1>
            <Link to="/" className="text-primary-600 hover:text-primary-700">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const catArticles = articles.filter((a) => a.category === slug);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <section className="pt-24 pb-8 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb items={[{ label: category.name }]} />

            <div className="flex items-center gap-4 mb-4">
              <div className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl ${
                category.color === 'accent' ? 'bg-accent-100 text-accent-600' : 'bg-primary-100 text-primary-600'
              }`}>
                <i className={`${category.icon} text-2xl`}></i>
              </div>
              <div>
                <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
                  {category.name}
                </h1>
                <p className="text-foreground-500 mt-1">{category.description}</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-4 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-wrap items-center gap-2 pb-6 border-b border-background-200/70">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                    cat.slug === slug
                      ? cat.color === 'accent'
                        ? 'bg-accent-500 text-background-50'
                        : 'bg-primary-500 text-background-50'
                      : 'bg-background-50 text-foreground-600 border border-background-200/70 hover:border-primary-200'
                  }`}
                >
                  <i className={`${cat.icon} text-sm`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            {catArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {catArticles.map((article) => (
                  <ArticleCard
                    key={article.id}
                    id={article.id}
                    title={article.title}
                    excerpt={article.excerpt}
                    category={article.category}
                    date={article.date}
                    readTime={article.readTime}
                    imageUrl={article.imageUrl}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-background-100">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类下暂无文章，敬请期待</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}